<template>
    <div class="call-back-app">
        <question-button v-if="isShowQuestionButton" v-on:show-form="showForm"></question-button>
        <transition name="bounce">
            <question-form v-if="isShowForm" v-on:on-close-form="onCloseForm" v-on:success-send-request="successSendRequest"></question-form>
        </transition>
        <thank-you-message v-if="isShowSuccess" v-on:on-close-success-msg="onCloseSuccessMsg"></thank-you-message>
    </div>
</template>

<script>
    import QuestionButton from './QuestionButton';
    import QuestionForm from './QuestionForm';
    import ThankYouMessage from './ThankYouMessage';

    export default {
        data: function () {
            return {
                isShowQuestionButton: true,
                isShowForm: false,
                clickedOnSubmit: false,
                isShowSuccess: false
            }
        },

        components: {
            QuestionButton,
            QuestionForm,
            ThankYouMessage
        },

        methods: {
            successSendRequest: function() {
                this.isShowForm = false;
                this.isShowSuccess = true;
            },
            showForm: function () {
                this.isShowQuestionButton = false;
                this.isShowForm = true;
            },
            onCloseForm: function() {
                this._showQuestionButton();
            },
            onCloseSuccessMsg: function() {
                this._showQuestionButton();
            },
            _showQuestionButton: function () {
                this.isShowQuestionButton = true;
                this.isShowForm = false;
                this.isShowSuccess = false;
            },
        }
    }
</script>

<style scoped>
    .call-back-app {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 101;
    }

    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    .bounce-leave-to {
        animation: bounce-in 0s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>


// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/callback/CallBack.vue